import { __updateTopicDiscussionComments, __deleteComment } from '@/store/helpers/discussion.helper.js'

export default {
  SET_DISCUSSION_COMMENTS(state, payload) {
    state.topicComments = payload;
  },
  SET_PRIVATE_DISCUSSION_COMMENTS(state, {comments, action='push'}={}) {
    comments.forEach(comment=>{
      if (!state.privateTopicCommentsIdArray.includes(comment.id)){
        if (action === 'push')
          state.privateTopicCommentsIdArray.push(comment.id)
        else if (action === 'unshift')
          state.privateTopicCommentsIdArray.unshift(comment.id)
        state.privateTopicComments.set(comment.id, comment)
      }
    })
  },
  SET_PUBLIC_DISCUSSION_COMMENTS(state,  {comments, action='push'}={}) {
     comments.forEach(comment=>{
      if (!state.publicTopicCommentsIdArray.includes(comment.id)){
        if (action === 'push')
          state.publicTopicCommentsIdArray.push(comment.id)
        else if (action === 'unshift')
          state.publicTopicCommentsIdArray.unshift(comment.id)
        state.publicTopicComments.set(comment.id, comment)
      }
    })
  },
  ADD_PUBLIC_DISCUSSION_COMMENTS(state, comment){
    if (comment?.parent){
      const parentComment = state.publicTopicComments.get(comment?.parent)
      parentComment.child.push(comment)
      state.publicTopicComments.set(parentComment?.id, parentComment)
    }else{
      state.publicTopicComments.set(comment?.id, comment)
      state.publicTopicCommentsIdArray.push(comment?.id)
    }
  },
  ADD_PRIVATE_DISCUSSION_COMMENTS(state, comment){
    if (comment?.parent){
      const parentComment = state.privateTopicComments.get(comment?.parent)
      parentComment.child.push(comment)
      state.privateTopicComments.set(parentComment?.id, parentComment)
    }else{
      state.privateTopicComments.set(comment?.id, comment)
      state.privateTopicCommentsIdArray.push(comment?.id)
    }
  },
  SET_TOPICS_CHATS(state, payload) {
    state.topicChats = payload;
  },
  SET_NEXT_URL(state, payload) {
    state.nextUrl = payload;
  },
  SET_CHATS_LOADER(state, payload) {
    state.chatsSkeletonLoader = payload;
  },
  UPDATE_COMMENT_PRIVATE_DISCUSSION: (state, comment)=>{
    state.privateTopicComments = __updateTopicDiscussionComments(state.privateTopicComments, comment)
  },
  UPDATE_COMMENT_PUBLIC_DISCUSSION: (state, comment)=>{
    state.publicTopicComments = __updateTopicDiscussionComments(state.publicTopicComments, comment)
  },
  SET_PUBLIC_DISUCSSION_USERS: (state, users) => state.publicDiscussionUsers = users,
  SET_PRIVATE_DISUCSSION_USERS: (state, users) => state.privateDiscussionUsers = users,
  TOGGLE_DICOVER_TOPIC_DISCUSSION_LOADER: (state, toggle) => {state.discoverTopicDiscussionLoader = toggle},

  DELETE_COMMENT_PRIVATE_DISCUSSION: (state,comment)=>{
    const {comments, commentIdArray} = __deleteComment(state.privateTopicComments, state.privateTopicCommentsIdArray, comment)
    if (!comment?.parent){
      state.privateTopicCommentsIdArray = commentIdArray
      state.privateTopicComments = comments
    }
    else{
      state.privateTopicComments = comments
    }
   },
  DELETE_COMMENT_PUBLIC_DISCUSSION: (state, comment)=>{
    const {comments, commentIdArray} = __deleteComment(state.publicTopicComments, state.publicTopicCommentsIdArray, comment)
    if (!comment?.parent){
      state.publicTopicCommentsIdArray = commentIdArray
      state.publicTopicComments = comments
    }
    else{
      state.publicTopicComments = comments
    }
    // state.publicTopicComments = __deleteTopicComment(state.publicTopicComments, comment)
   },
   SET_SELECTED_DISCUSSION_ARTICLE_ID: (state, articleId) =>{ state.selectedDiscussionArticleId = articleId },
   SET_DISCUSSION_INVITED_USERS(state, payload) {
    state.topicDiscussionInvitedUsers = payload;
  },
  SET_PRIVATE_DISCUSSION_CHAT_CURRENT_PAGE(state, payload){
    state.privateDiscussionChatCurrentPage = payload
  },
  SET_PUBLIC_DISCUSSION_CHAT_CURRENT_PAGE(state, payload){
    state.publicDiscussionChatCurrentPage = payload
  },
  RESET_DISCUSSION_CHAT_CURRENT_PAGE(state){
    state.privateDiscussionChatCurrentPage = 1
    state.publicDiscussionChatCurrentPage = 1
    state.isMoreDiscussionChatPage = false
  },
  SET_DISCUSSION_CHAT_LIMIT(state, payload){
    state.isMoreDiscussionChatPage = payload
  },
  EMPTY_TOPIC_PUBLIC_PRIVATE_DISCUSSIONS(state){
    state.publicTopicComments = new Map()
    state.privateTopicComments = new Map()
    state.publicTopicCommentsIdArray = []
    state.privateTopicCommentsIdArray = []
  },
  SET_TYPING_USERS(state, users){
    state.typingUsers = users
  },
  UPDATE_SEARCHED_COMMENT(state, comment){
    state.searchedComment = comment
  },
}